import Favicon16 from './assets/images/favicon-32x32.png?enhanced&w=16&h=16&quality=100&lossless=false'
import Favicon32 from './assets/images/favicon-32x32.png?enhanced&w=32&h=32&quality=100&lossless=false'

export const images = {
    favicon16: Favicon16,
    favicon32: Favicon32
}